import type { Plugin } from './types';
import type { WebSocketPayload } from '@/helpers/websocket';
import GrainFoxWebSocket from '@/helpers/websocket';

const WebSocketPlugin: Plugin = {
  install: (Vue, { store }): void => {
    if (!store) {
      throw new Error('Please provide vuex store');
    }

    function handleNewChatMessage(message: WebSocketPayload): void {
      store.dispatch('chat/onNewMessage', message);
      store.dispatch('chat/updateInteraction', message.conversation);
    }

    function handleWebsocketOpen(): void {
      store.commit('app/setIsWebsocketOpen', true);
    }

    function handleWebsocketClose(): void {
      store.commit('app/setIsWebsocketOpen', false);
    }

    const handleWebinarOrganizerMessage = (message: WebSocketPayload): void => {
      store.dispatch('webinarChat/onOrganizerMessage', message);
    };

    const handleWebinarPrivateMessage = (message: WebSocketPayload): void => {
      store.dispatch('webinarChat/onPrivateMessage', message);
    };

    const handleWebinarPollCreated = (message: WebSocketPayload): void => {
      store.dispatch('webinarChat/onPollCreated', message);
    };

    const handleWebinarPollClosed = (message: WebSocketPayload): void => {
      store.dispatch('webinarChat/onPollClosed', message);
    };

    const handleWebinarPollResultsUpdate = (message: WebSocketPayload): void => {
      store.dispatch('webinarChat/onPollResultsUpdate', message);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const unsubscribe = store.subscribe((mutation, state: any) => {
      if (mutation.type === 'user/setIsLoggedIn' && mutation.payload) {
        const isLocal = !state.app.isStaging && !state.app.isProduction;
        Vue.prototype.$gfws = new GrainFoxWebSocket(isLocal); // eslint-disable-line new-cap

        try {
          Vue.prototype.$gfws.registerCallback('chat_message', handleNewChatMessage);
          Vue.prototype.$gfws.registerCallback('on_websocket_open', handleWebsocketOpen);
          Vue.prototype.$gfws.registerCallback('on_websocket_close', handleWebsocketClose);
          Vue.prototype.$gfws.registerCallback('webinar_organizer_message', handleWebinarOrganizerMessage);
          Vue.prototype.$gfws.registerCallback('webinar_private_message', handleWebinarPrivateMessage);
          Vue.prototype.$gfws.registerCallback('webinar_poll_created', handleWebinarPollCreated);
          Vue.prototype.$gfws.registerCallback('webinar_poll_closed', handleWebinarPollClosed);
          Vue.prototype.$gfws.registerCallback('webinar_poll_results_update', handleWebinarPollResultsUpdate);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('Error establishing websocket connection');
        }

        unsubscribe();
      }
    });
  },
};

export default WebSocketPlugin;
